import { ClassNameProps, Column, If, Image, isBefore, Row, stringToLocalDate, StyleProps } from "@hex-insights/core";
import {
	CircleLoadingPlaceholder,
	MediaLoadingPlaceholder,
	TextLineLoadingPlaceholder,
} from "../../../../Components/LoadingPlaceholder";
import { StaticURLs } from "../../../../StaticURLs";
import { AcademicTerm } from "../../../../Utilities";
import { AcademicTermFormat } from "../../../Format";
import { AcademicTermLink } from "../../../Links";
import styles from "./styles.module.css";

export type TimelineItemAcademicTerm = Pick<AcademicTerm, "id" | "name" | "imageURL" | "startDate" | "endDate">;

export type TimelineItemProps = {
	isLoading?: boolean;
	academicTerm: TimelineItemAcademicTerm | null | undefined;
} & Partial<ClassNameProps & StyleProps>;

export function TimelineItem({ isLoading, academicTerm, className, style }: TimelineItemProps) {
	if (!academicTerm && isLoading) {
		return (
			<div className={className} style={style}>
				<Column justify="spaced-start">
					<Row justify="spaced-start" align="center">
						<CircleLoadingPlaceholder size="2.5rem" />
						<TextLineLoadingPlaceholder className={styles["timeline-item__text"]}>
							Season 0000 has started!
						</TextLineLoadingPlaceholder>
					</Row>

					<MediaLoadingPlaceholder style={{ width: "100%", height: "15rem" }} />
				</Column>
			</div>
		);
	}
	if (!academicTerm) {
		return null;
	}

	const verb = isBefore(new Date(), stringToLocalDate(academicTerm.endDate, "day"), "day") ? "has started" : "started";

	return (
		<div className={className} style={style}>
			<Column justify="spaced-start">
				<Row justify="spaced-start" align="center">
					<Image src={StaticURLs.Images.veritaWingsSymmetricSmall} sizing="width-scaled" style={{ width: "2.5rem" }} />

					<Column justify="spaced-start" verticalSpacing="0.25rem">
						<span className={styles["timeline-item__text"]}>
							<strong>
								<AcademicTermLink instance={academicTerm} className="link--no-text-decoration" />
							</strong>{" "}
							{verb}!
						</span>
						<span className={styles["timeline-item__date-range"] + " timestamp"}>
							{AcademicTermFormat.Fields.startDate(academicTerm.startDate)} to{" "}
							{AcademicTermFormat.Fields.endDate(academicTerm.endDate)}
						</span>
					</Column>
				</Row>

				<If condition={!!academicTerm.imageURL}>
					<Image src={academicTerm.imageURL} sizing="width-scaled" style={{ width: "100%" }} />
				</If>
			</Column>
		</div>
	);
}
